import { createAsyncThunk } from '@reduxjs/toolkit';
import { DetailedPollResultsPayload } from 'features/polls/types';
import { selectPollDetailedResults } from 'features/polls/pollsSlice';
import { RootState } from 'store/store';
import { requestDetailedPollResultsService } from 'features/polls/services';

/**
 * Thunk for requesting detailed poll results.
 * Uses service layer for clean separation of concerns and to keep API logic isolated.
 */
export const requestDetailedPollResults = createAsyncThunk<
  DetailedPollResultsPayload,
  string,
  {
    state: RootState;
  }
>('polls/requestDetailedPollResults', requestDetailedPollResultsService, {
  condition: (id, { getState }) => {
    const pollResults = selectPollDetailedResults(getState(), id);
    const { status } = pollResults || {};

    return !(pollResults && (status === 'loading' || status === 'success'));
  },
});
